export default 'light'
